// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/LgpdTermAcceptances_SaveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /lgpd_term_acceptances/save
 *
 * Returns the recorded acceptance entry.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface LgpdTermAcceptances_SaveResponseDados {
id: number
cliente_id: number
term_id: number
}

export type LgpdTermAcceptances_SaveResponse = ApiResponse<LgpdTermAcceptances_SaveResponseDados>;

registerResponseContract('LgpdTermAcceptances_SaveResponse', {
  id:         { type: 'number',  required: true },
  cliente_id: { type: 'number',  required: true },
  term_id:    { type: 'number',  required: true },
})
